import React, { Component } from "react";
import './personalloanads.css';

class PersonalLoanformerEmployee extends Component {
  render() {
    return (
      <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <a href="/home" className="a-breadcrumbs">หน้าแรก</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการด้านสินเชื่อ</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">เงินกู้สามัญ</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="/personalloanformeremployee" className="a-breadcrumbs">อดีตพนักงาน</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50" style={{width: '90%', fontFamily: '"Cordia New"'}}>
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>อดีตพนักงาน</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <p style={{fontSize:'20px'}}><b>เงินกู้สามัญอดีตพนักงาน</b></p>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th>วงเงิน</th>
                      <th>งวดชำระ(ไม่เกิน)</th>
                      <th>หลักประกัน</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        80 % ของมูลค่าหุ้น
                      </td>                               
                      <td>
                        150
                      </td>
                      <td>หุ้นค้ำตามมูลค่าหนี้</td>
                    </tr>  
                  </tbody>
                </table>
                <p style={{fontSize:'20px'}}><b>เงินกู้สามัญเกษียณ</b></p>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th>วงเงินกู้สูงสุด(บาท)</th>
                      <th>งวดชำระ(ไม่เกิน)</th>
                      <th>หลักประกัน</th>
                      <th>หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{width: 200}}>
                        50 % ของมูลค่าหุ้น
                      </td>                               
                      <td>
                        ไม่ต้องผ่อนชำระ(สหกรณ์จะหักดอกเบี้ยจากเงินปันผล)
                      </td>
                      <td>หุ้นค้ำตามมูลค่าหนี้</td>
                      <td>สมาชิกอดีตพนักงานฯ ที่ใช้วงเงินกู้สามัญตามเงื่อนไข 50% ของมูลค่าหุ้น จะชำระหนี้ทั้งหมดได้เมื่อมีความประสงค์จะลาออกจากการเป็นสมาชิกของสหกรณ์</td>
                    </tr>  
                  </tbody>
                </table>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default PersonalLoanformerEmployee;
